module.exports = __webpack_public_path__ + "static/media/valor3_2.9a735e0f.png";